import { userSelector } from '@store/selectors/user';
import { tables } from '@store/tables';
import { of } from 'rxjs';

export const handleTableOccupancy = (socketMessage, state) => {
  const { tableId, TableOccupied, ClientIds } = socketMessage;
  const { uid, operatorId } = userSelector(state);

  const isOccupied = TableOccupied && !(ClientIds || []).includes(`${operatorId}|${uid}|${tableId}`);

  return of(
    tables.updateTable([
      {
        tableId,
        isOccupied,
      },
    ])
  );
};
